import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import useApi from "$src/core/hooks/use-api";
import { queryKey as subscriptionOffersQueryKey } from "$src/core/queries/use-subscription-offers-query";
import { queryKey as subscriptionsQueryKey } from "$src/core/queries/use-subscription-query";

const MUTATION_KEY = ["subscription-offer-activate"];

type Variables = {
  offerId: string;
  coupon?: string;
};

const useSubscriptionOfferActivateMutation = () => {
  const queryClient = useQueryClient();
  const { api } = useApi();

  const mutationFn = useCallback(
    ({ offerId, coupon }: Variables) =>
      api.activateSubscriptionOffer(offerId, coupon),
    [api],
  );

  return useMutation({
    mutationKey: MUTATION_KEY,
    mutationFn,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: subscriptionOffersQueryKey(),
        }),
        queryClient.invalidateQueries({
          queryKey: subscriptionsQueryKey(),
        }),
      ]);
    },
  });
};

export default useSubscriptionOfferActivateMutation;
